import {Component} from '@angular/core';
import {
  faArrowRight,
  faBusinessTime,
  faCalendarDays,
  faCaretDown,
  faCaretRight,
  faIndustry,
  faLocationDot,
  faMoneyCheckDollar
} from "@fortawesome/free-solid-svg-icons";
import {ActivatedRoute, ParamMap, Params, Router} from "@angular/router";
import {debounceTime, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import RestHelper from "../../../Helper/RestHelper";
import {RestResponse} from "../../../Interfaces/RestResponse.interface";
import {Job} from "../../../Interfaces/job.interface";
import Utils from "../../../Helper/Utils";
import {LoaderService} from "../../../services/loader/loader.service";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {Filter} from "../../../Interfaces/filter.interface";
import {Filterresponse} from "../../../Interfaces/filterresponse.interface";

@Component({
  selector: 'app-jobsuche',
  templateUrl: './jobsuche.component.html',
  styleUrl: './jobsuche.component.css'
})
export class JobsucheComponent {

  mapmarker = faLocationDot
  publishingdate = faCalendarDays
  industryicon = faIndustry
  time = faBusinessTime
  arrowright = faArrowRight
  caretdown = faCaretDown
  caretup = faCaretRight
  salary = faMoneyCheckDollar

  isCollapsedSearch = false
  isCollapsedContract = false
  isCollapsedTimeModel = false
  isCollapsedBranche = false
  isCollapsedRemote = false
  isCollapsedEducation = false
  isCollapsedCarrerLevel = false

  protected readonly Utils = Utils;
  public jobs: Observable<Job[]> | undefined
  public apierror: boolean = false
  public resultsize: number = -1

  public filterForm: FormGroup | undefined

  public getFormArray(name: string) {
    return this.filterForm?.get(name) as FormArray;
  }

  public industry: Filter[] | undefined
  public contracttypes: Filter[] | undefined
  public timemodels: Filter[] | undefined
  public education: Filter[] | undefined
  public carrerlevel: Filter[] | undefined
  public remote: Filter[] | undefined

  public filters: Filterresponse[] | undefined

  constructor(private httpClient: HttpClient, protected loader: LoaderService, private route: ActivatedRoute, private formBuilder: FormBuilder, protected router: Router) {

    this.loader.showLoader()

    this.route.queryParamMap.subscribe(queryParams => {

      this.httpClient.get<RestResponse<Filterresponse[]>>(RestHelper.API_BASE_URL + "searchfilter/getSearchFilter", RestHelper.requestOptions).subscribe({
        next: (value) => {

          this.industry = value.data.filter(value1 => value1.filterName === "industry")?.at(0)?.filter
          this.contracttypes = value.data.filter(value1 => value1.filterName === "contract_type")?.at(0)?.filter
          this.timemodels = value.data.filter(value1 => value1.filterName === "timemodel")?.at(0)?.filter
          this.education = value.data.filter(value1 => value1.filterName === "education")?.at(0)?.filter
          this.carrerlevel = value.data.filter(value1 => value1.filterName === "carrer_level")?.at(0)?.filter
          this.remote = value.data.filter(value1 => value1.filterName === "remote")?.at(0)?.filter

          this.filters = value.data

          this.filterForm = this.formBuilder.group({
            search: [],
            contract_type: this.formBuilder.array(this.contracttypes ? this.contracttypes.map(() => this.formBuilder.control(false)) : []),
            timemodel: this.formBuilder.array(this.timemodels ? this.timemodels.map(() => this.formBuilder.control(false)) : []),
            remote: this.formBuilder.array(this.remote ? this.remote.map(() => this.formBuilder.control(false)) : []),
            industry: this.formBuilder.array(this.industry ? this.industry.map(() => this.formBuilder.control(false)) : []),
            carrerlevel: this.formBuilder.array(this.carrerlevel ? this.carrerlevel.map(() => this.formBuilder.control(false)) : []),
            education: this.formBuilder.array(this.education ? this.education.map(() => this.formBuilder.control(false)) : [])
          })

          this.patchFormCheckbox(queryParams, "contract_type", this.contracttypes)
          this.patchFormCheckbox(queryParams, "timemodel", this.timemodels)
          this.patchFormCheckbox(queryParams, "remote", this.remote)
          this.patchFormCheckbox(queryParams, "industry", this.industry)
          this.patchFormCheckbox(queryParams, "education", this.education)
          this.patchFormCheckbox(queryParams, "carrer_level", this.carrerlevel)

          this.jobs = this.getJobs();

          this.filterForm.controls['search'].valueChanges.pipe(
            debounceTime(300)
          ).subscribe(() => {
            this.jobs = this.getJobs()
          })

        }, error: () => {
          this.apierror = true
          this.loader.hideLoader()
        }
      })
    })
  }

  private patchFormCheckbox(queryParams: ParamMap, paramname: string, values: Filter[] | undefined) {
    if (values === undefined) return
    const formarray = this.getFormArray(paramname);

    if (queryParams.has(paramname)) {
      queryParams.getAll(paramname).forEach(value => {
        for (let i = 0; i < values.length; i++) {
          if (values[i].filtername === value) {
            formarray.at(i).patchValue(true)
          }
        }
      })
    }
  }

  public updateQuery(updateparam: Params, deleteparams: Params, category: string, name: string) {

    let all = this.route.snapshot.queryParamMap.getAll(category);

    if (!all || !all.includes(name)) {
      if (!all.includes(name)) {
        updateparam[category] = [name, ...all]
      }
      // noinspection JSIgnoredPromiseFromCall
      this.router.navigate([], {
        queryParams: updateparam,
        queryParamsHandling: 'merge',
      });
      return
    }

    all = all.filter(value => value !== name)

    if (all.length !== 0) {
      deleteparams[category] = [...all]
    }

    // noinspection JSIgnoredPromiseFromCall
    this.router.navigate([], {
      queryParams: deleteparams,
      queryParamsHandling: 'merge',
    });
  }

  private getJobs(sortby: string = "", sorttype: string = ""): Observable<Job[]> {

    const urlSearchParams = new URLSearchParams();

    if (sortby !== "") {
      urlSearchParams.set("sortby", sortby);
    }
    if (sorttype !== "") {
      urlSearchParams.set("sorttype", sorttype);
    }
    for (let valueKey in this.filterForm?.value) {

      if (valueKey === "search") {
        const searchvalue = this.filterForm?.value[valueKey];
        if (searchvalue !== null && searchvalue !== "") {
          urlSearchParams.append("index", this.filterForm?.value[valueKey])
        }
        break
      }

      const values = this.filterForm?.value[valueKey];
      for (let i = 0; i < values.length; i++) {
        if (values[i]) {
          const activefilter = this.filters?.filter(value => value.filterName === valueKey).at(0)!.filter.at(i);
          if (activefilter) {
            console.log(activefilter)
            urlSearchParams.append(valueKey, activefilter.id.toString())
          }
        }
      }
    }

    console.log(urlSearchParams.toString())

    return new Observable(subscriber => {

      this.httpClient.get<RestResponse<Job[]>>(RestHelper.API_BASE_URL + "job/getJobList?" + urlSearchParams.toString(), RestHelper.requestOptions).subscribe({
        next: (value) => {
          this.resultsize = value.recordsFiltered
          subscriber.next(value.data)
          this.loader.hideLoader()
        }, error: () => {
          this.apierror = true
          this.loader.hideLoader()
        }
      })
    })
  }
}
